import * as styles from "./PaginationPageJump.css";

import type { JSX } from "react";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@frontend/components/atoms/Select";
import { useLingui } from "@lingui/react/macro";

import type { PaginationPageJumpProps } from "./Pagination.types";

export function PaginationPageJump({
  page,
  pageCount,
  size,
  disabled,
  onPageChange,
}: PaginationPageJumpProps): JSX.Element {
  const { t } = useLingui();

  const pages = Array.from({ length: Math.max(pageCount, 0) }, (_, i) => i + 1);

  return (
    <Select
      size={size}
      value={page}
      disabled={disabled}
      onValueChange={(value) => value !== null && onPageChange(value)}
    >
      <SelectTrigger
        data-slot="pagination-jump"
        aria-label={t`Go to page`}
        className={styles.jump}
        // Room for the longest page number, so the row holds still while paging.
        style={{ minWidth: `calc(${String(pageCount).length}ch + 3.5em)` }}
      >
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {pages.map((value) => (
          <SelectItem key={value} value={value}>
            {value}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
